import React from "react";
import CompleteSetup from "../../components/common/CompleteSetup";

const AccountSetup = () => {
  return <CompleteSetup />;
};

export default AccountSetup;
